import get from 'lodash/get';
import has from 'lodash/has';
import isObjectLike from 'lodash/isObjectLike';
import isString from 'lodash/isString';
import mapValues from 'lodash/mapValues';

/* eslint-disable */

const PATH_PREFIX = 'PATH:';

/**
 * Returns the value if it's a scalar value, otherwise the path to the value
 * so it can be extracted later.
 *
 * @param {*} data
 * @param {*} path
 * @param {*} defaultValue
 */
const getPathValue = (data, path, defaultValue = null) => {
  // Log a warning in case the value can't be found.
  if (!has(data, path) && process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line
    console.warn(`"${path}" field was not found in: ${JSON.stringify(data)}`);
    return defaultValue;
  }

  // Get the value from the JSON object.
  const dataValue = get(data, path, defaultValue);

  // If it's an array or object, return the path so we can extract the value later.
  if (Array.isArray(dataValue) || isObjectLike(dataValue)) {
    return `${PATH_PREFIX}${path}`;
  }

  return dataValue;
};

/**
 * Replaces all placeholder values in a string with the given data object..
 */
const replacePlaceholderValuesInString = (data) => (value) => {
  // Replace all matched vars.
  const replaceValue = value.replace(/\${(.*?)}/g, (match) => {
    const path = match.substring(2, match.length - 1);
    return getPathValue(data, path, match);
  });

  /**
   * If the value is a path, let's check if it's a valid value and return it.
   * This can be an array for example instead of a scalar type. We need this,
   * because a non-scalar type can't be used directory in the `.replace` above.
   */
  if (replaceValue.startsWith(PATH_PREFIX)) {
    const path = replaceValue.substring(PATH_PREFIX.length);

    if (has(data, path)) {
      return get(data, path);
    }
  }

  return replaceValue;
};

/**
 * Replaces all values recursively with values from a JSON object.
 */
const replacePlaceholderValues = (data) => (value) => {
  if (Array.isArray(value)) {
    return value.map(replacePlaceholderValues(data));
  }

  if (isObjectLike(value)) {
    return mapValues(value, replacePlaceholderValues(data));
  }

  if (isString(value)) {
    const replacePlaceholders = replacePlaceholderValuesInString(data);
    const stringValue = replacePlaceholders(value);

    if (['null', 'undefined'].includes(stringValue)) {
      return null;
    }

    return stringValue;
  }

  return value;
};

export default replacePlaceholderValues;

/* eslint-enable */
